import { Outlet } from 'react-router-dom';
import { WarehouseProvider } from 'modules/warehouse';

const WarehouseWrapper = () => {
    return (
        <WarehouseProvider>
            <Outlet />
        </WarehouseProvider> 
    );
};

export default WarehouseWrapper;